<p-drawer
  [(visible)]="visible"
  position="right"
  styleClass="efetivo-drawer-dark"
  [modal]="true"
  [closable]="true"
  header="Novo Efetivo"
  (onHide)="closeDrawer()"
>
  <!-- Corpo com scroll (todas as secções) -->
  <div class="modal-body">
    <div class="form-sections">
      <!-- DADOS PESSOAIS -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-user"></i> Dados Pessoais
        </h4>

        <!-- ── FOTO DO COLABORADOR (COMPLETO) ── -->
        <div class="foto-section">
          <div class="foto-wrap">
            <div class="foto-circle" (click)="fotoInput.click()">
              <img
                *ngIf="fotoPreviewUrl"
                [src]="fotoPreviewUrl"
                alt="Foto do efetivo"
                class="foto-img"
              />
              <div *ngIf="!fotoPreviewUrl" class="foto-placeholder">
                <i class="fas fa-camera"></i>
                <span>Foto</span>
              </div>
              <div class="foto-overlay">
                <i class="fas fa-pencil-alt"></i>
              </div>
            </div>
            <input
              #fotoInput
              type="file"
              accept="image/jpeg,image/png,image/webp"
              hidden
              (change)="onFotoSelect($event)"
            />
          </div>

          <div class="foto-info">
            <p class="foto-hint">Fotografia do colaborador</p>
            <div class="foto-actions">
              <button
                type="button"
                class="btn-web-secondary"
                (click)="fotoInput.click()"
              >
                <i class="fas fa-upload"></i>
                {{ selectedFoto ? "Alterar foto" : "Selecionar foto" }}
              </button>
              <button
                type="button"
                class="btn-web-secondary"
                (click)="openCamera()"
              >
                <i class="fas fa-video"></i>
                Usar Câmara
              </button>
              <button
                type="button"
                class="btn-web-danger"
                *ngIf="selectedFoto"
                (click)="removeFoto()"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
            <small *ngIf="selectedFoto" class="foto-selected-name">
              <i class="fas fa-check-circle" style="color: var(--green)"></i>
              {{ selectedFoto.name }}
            </small>
            <small *ngIf="!selectedFoto" class="foto-meta"
              >JPG, PNG, WEBP · Máx. 5 MB · Opcional</small
            >
          </div>
        </div>

        <!-- ── CAMERA OVERLAY (mantida exatamente como no original) ── -->
        <div class="camera-overlay" *ngIf="cameraOpen" (click)="closeCamera()">
          <div class="camera-modal" (click)="$event.stopPropagation()">
            <div class="camera-modal-header">
              <span>Tirar Fotografia</span>
              <button
                type="button"
                class="btn-close-camera"
                (click)="closeCamera()"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div class="camera-body">
              <div class="camera-viewfinder" *ngIf="!capturedPhotoUrl">
                <video
                  #cameraVideo
                  class="camera-video"
                  autoplay
                  playsinline
                  muted
                ></video>
                <div class="camera-guide-ring"></div>
              </div>

              <div class="camera-preview" *ngIf="capturedPhotoUrl">
                <img
                  [src]="capturedPhotoUrl"
                  class="camera-preview-img"
                  alt="Prévia"
                />
              </div>
            </div>

            <div class="camera-actions">
              <ng-container *ngIf="!capturedPhotoUrl">
                <button
                  type="button"
                  class="btn-capture"
                  (click)="capturePhoto()"
                >
                  <i class="fas fa-camera"></i>
                </button>
              </ng-container>
              <ng-container *ngIf="capturedPhotoUrl">
                <button
                  type="button"
                  class="btn-web-secondary"
                  (click)="retakePhoto()"
                >
                  <i class="fas fa-sync-alt"></i> Repetir
                </button>
                <button
                  type="button"
                  class="btn-primary-cam"
                  (click)="confirmPhoto()"
                >
                  <i class="fas fa-check"></i> Usar esta foto
                </button>
              </ng-container>
            </div>

            <canvas #cameraCanvas style="display: none"></canvas>
          </div>
        </div>

        <form [formGroup]="dadosPessoaisForm">
          <div class="form-grid-2">
            <div class="form-group">
              <label>Nº BI <span class="required-mark">*</span></label>
              <div class="bi-search-row">
                <input
                  pInputText
                  type="text"
                  formControlName="numBI"
                  placeholder="000000000LA000"
                  class="form-input"
                />
                <button
                  type="button"
                  class="btn-bi-search"
                  (click)="searchBI()"
                  [disabled]="biSearching"
                >
                  <i
                    [class]="
                      biSearching ? 'fas fa-spinner fa-spin' : 'fas fa-search'
                    "
                  ></i>
                  {{ biSearching ? "A pesquisar..." : "Pesquisar" }}
                </button>
              </div>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'numBI', 'required')">
                O número do BI é obrigatório.
              </small>
            </div>
            <div class="form-group">
              <label>Nome Completo <span class="required-mark">*</span></label>
              <input
                pInputText
                type="text"
                formControlName="nome"
                placeholder="Ex: João Manuel da Silva"
                class="form-input"
              />
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'nome', 'required')">
                O nome completo é obrigatório.
              </small>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'nome', 'minlength')">
                O nome deve ter pelo menos 3 caracteres.
              </small>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'nome', 'maxlength')">
                O nome não pode exceder 100 caracteres.
              </small>
            </div>
            <div class="form-group">
              <label>Data Nascimento <span class="required-mark">*</span></label>
              <p-datePicker
                formControlName="dataNascimento"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [maxDate]="maxDate"
                styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
              ></p-datePicker>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'dataNascimento', 'required')">
                A data de nascimento é obrigatória.
              </small>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'dataNascimento', 'minAge')">
                O efetivo deve ter pelo menos 18 anos.
              </small>
            </div>
            <div class="form-group">
              <label>Género <span class="required-mark">*</span></label>
              <p-select
                formControlName="genero"
                [options]="generos"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o género"
                styleClass="form-input"
              ></p-select>
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'genero', 'required')">
                Selecione o género.
              </small>
            </div>
            <div class="form-group">
              <label>Telefone <span class="required-mark">*</span></label>
              <div class="phone-input">
                <span>+244</span>
                <p-inputMask
                  formControlName="numTelefone"
                  mask="999 999 999"
                  [unmask]="true"
                  placeholder="923 000 000"
                  styleClass="form-input no-left-border"
                ></p-inputMask>
              </div>
              <small
                class="sp-error"
                *ngIf="hasFieldError(dadosPessoaisForm, 'numTelefone', 'required')"
              >
                O telefone é obrigatório.
              </small>
              <small
                class="sp-error"
                *ngIf="hasFieldError(dadosPessoaisForm, 'numTelefone', 'pattern')"
              >
                Introduza um telefone válido com 9 dígitos iniciado por 9.
              </small>
            </div>
            <div class="form-group">
              <label>Email <span class="required-mark">*</span></label>
              <input
                pInputText
                type="email"
                formControlName="email"
                placeholder="joao@email.com"
                class="form-input"
              />
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'email', 'email')">
                Introduza um endereço de email válido.
              </small>
            </div>
            <div class="form-group full">
              <label>Morada <span class="required-mark">*</span></label>
              <input
                pInputText
                type="text"
                formControlName="modara"
                placeholder="Rua, Bairro, Município"
                class="form-input"
              />
              <small class="sp-error" *ngIf="hasFieldError(dadosPessoaisForm, 'modara', 'required')">
                A morada é obrigatória.
              </small>
            </div>
          </div>
        </form>
      </div>

      <!-- DADOS PROFISSIONAIS -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-briefcase"></i> Dados Profissionais
        </h4>
        <form [formGroup]="dadosProfissionaisForm">
          <div class="form-grid-2">
            <div class="form-group">
              <label>Função <span class="required-mark">*</span></label>
              <p-select
                formControlName="idFuncao"
                [options]="funcoes"
                optionLabel="nome"
                optionValue="id"
                placeholder="Selecione a função"
                styleClass="form-input"
              ></p-select>
              <small class="sp-error" *ngIf="hasFieldError(dadosProfissionaisForm, 'idFuncao', 'required')">
                Selecione a função.
              </small>
            </div>
            <div class="form-group">
              <label>Categoria <span class="required-mark">*</span></label>
              <p-select
                formControlName="idCategoria"
                [options]="categorias"
                optionLabel="nome"
                optionValue="id"
                placeholder="Selecione a categoria"
                styleClass="form-input"
              ></p-select>
              <small class="sp-error" *ngIf="hasFieldError(dadosProfissionaisForm, 'idCategoria', 'required')">
                Selecione a categoria.
              </small>
            </div>
            <div class="form-group">
              <label>Data Admissão <span class="required-mark">*</span></label>
              <p-datePicker
                formControlName="dataAdmissao"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [maxDate]="todayDate"
                styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
              ></p-datePicker>
              <small class="sp-error" *ngIf="hasFieldError(dadosProfissionaisForm, 'dataAdmissao', 'required')">
                A data de admissão é obrigatória.
              </small>
            </div>
            <div class="form-group">
              <label>MEC</label>
              <input
                pInputText
                type="text"
                formControlName="codigoMec"
                placeholder="Ex: MEC-00123"
                class="form-input"
              />
            </div>

            <div class="form-group full">
              <label>Salário (AOA)</label>
              <p-inputNumber
                formControlName="salario"
                mode="currency"
                currency="AOA"
                locale="pt-AO"
                [min]="0"
                styleClass="form-input"
              ></p-inputNumber>
            </div>
            <div class="form-group full">
              <div class="form-grid-banco">
                <div class="form-group">
                  <label>Banco</label>
                  <p-select
                    formControlName="Banco"
                    [options]="angolanBanks"
                    optionValue="value"
                    optionLabel="label"
                    [showClear]="true"
                    [filter]="true"
                    placeholder="Selecione o banco"
                    styleClass="form-input"
                    (onChange)="onBancoChange($event)"
                  >
                  </p-select>
                </div>
                <div class="form-group">
                  <label>IBAN</label>
                  <p-inputMask
                    formControlName="Iban"
                    [mask]="ibanMask"
                    placeholder="Selecione o banco primeiro"
                    styleClass="form-input iban-input"
                  ></p-inputMask>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- DOCUMENTAÇÃO -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-file"></i> Documentação
        </h4>
        <div class="form-grid-3">
          <!-- Certificado de Formação -->
          <div class="doc-upload-zone" (click)="certificadoInput.click()">
            <i class="fas fa-file-pdf"></i>
            <span>Certificado de Formação</span>
            <small *ngIf="fileInfo['certificadoFormacao']; else noCert">
              {{ fileInfo["certificadoFormacao"].name }}
            </small>
            <ng-template #noCert>
              <small>Arraste ou clique</small>
            </ng-template>
            <input
              #certificadoInput
              type="file"
              hidden
              (change)="onFileSelect($event, 'certificadoFormacao')"
            />
          </div>

          <!-- Registo Criminal -->
          <div class="doc-upload-zone" (click)="registroInput.click()">
            <i class="fas fa-file-pdf"></i>
            <span>Registo Criminal</span>
            <small *ngIf="fileInfo['registroCriminal']; else noReg">
              {{ fileInfo["registroCriminal"].name }}
            </small>
            <ng-template #noReg>
              <small>Arraste ou clique</small>
            </ng-template>
            <input
              #registroInput
              type="file"
              hidden
              (change)="onFileSelect($event, 'registroCriminal')"
            />
          </div>

          <!-- Atestado Médico -->
          <div class="doc-upload-zone" (click)="atestadoInput.click()">
            <i class="fas fa-file-pdf"></i>
            <span>Atestado Médico</span>
            <small *ngIf="fileInfo['atestadoMedico']; else noAtest">
              {{ fileInfo["atestadoMedico"].name }}
            </small>
            <ng-template #noAtest>
              <small>Arraste ou clique</small>
            </ng-template>
            <input
              #atestadoInput
              type="file"
              hidden
              (change)="onFileSelect($event, 'atestadoMedico')"
            />
          </div>
        </div>
      </div>

      <!-- CONTACTO DE EMERGÊNCIA -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-phone"></i> Contacto de Emergência
        </h4>
        <form [formGroup]="documentacaoForm">
          <div class="form-grid-2">
            <div class="form-group">
              <label>Nome <span class="required-mark">*</span></label>
              <input
                pInputText
                type="text"
                formControlName="nomeContactoEmergencia"
                placeholder="Nome do familiar"
                class="form-input"
              />
              <small class="sp-error" *ngIf="hasFieldError(documentacaoForm, 'nomeContactoEmergencia', 'required')">
                O nome do contacto é obrigatório.
              </small>
              <small class="sp-error" *ngIf="hasFieldError(documentacaoForm, 'nomeContactoEmergencia', 'minlength')">
                O nome deve ter pelo menos 3 caracteres.
              </small>
              
              <small class="sp-error" *ngIf="hasFieldError(documentacaoForm, 'nomeContactoEmergencia', 'pattern')">
                O nome deve conter apenas letras e espaços.
              </small>

            </div>
            <div class="form-group">
              <label>Parentesco <span class="required-mark">*</span></label>
              <p-select
                formControlName="parentescoContactoEmergencia"
                [options]="parentescos"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                styleClass="form-input"
              ></p-select>
              <small class="sp-error" *ngIf="hasFieldError(documentacaoForm, 'parentescoContactoEmergencia', 'required')">
                Selecione o parentesco.
              </small>
            </div>
            <div class="form-group">
              <label>Telefone <span class="required-mark">*</span></label>
              <div class="phone-input">
                <span>+244</span>
                <p-inputMask
                  formControlName="numTelContactoEmergencia"
                  mask="999 999 999"
                  [unmask]="true"
                  placeholder="923 000 000"
                  styleClass="form-input no-left-border"
                ></p-inputMask>
              </div>
              <small
                class="sp-error"
                *ngIf="hasFieldError(documentacaoForm, 'numTelContactoEmergencia', 'required')"
              >
                O telefone do contacto é obrigatório.
              </small>
              <small
                class="sp-error"
                *ngIf="hasFieldError(documentacaoForm, 'numTelContactoEmergencia', 'pattern')"
              >
                Introduza um telefone válido com 9 dígitos iniciado por 9.
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Botões finais (iguais ao modal original) -->
    <div class="modal-actions">
      <button type="button" class="btn-web-secondary" (click)="closeDrawer()">
        Cancelar
      </button>
      <button
        class="btn-web-primary"
        pButton
        (click)="onSubmit()"
        [disabled]="loading || !podeGuardar"
        [loading]="loading"
      >
        <i class="fas fa-check"></i> Guardar Efetivo
      </button>
    </div>
  </div>
</p-drawer>
